import { Controller } from "@hotwired/stimulus"
import { api } from "../services/api";

export default class extends Controller {
  static outlets = [ "app" ]
  static values = {
    renderPath: String
  }

  declare readonly appOutlet: any;
  declare readonly renderPathValue: string
  static targets = [ "attachment" ]
  declare readonly attachmentTargets: HTMLElement[];

  get form(): HTMLFormElement { return this.element as HTMLFormElement }

  connect() {
  }

  attachmentTargetConnected(e: Event) {
    console.log('attachmentTargetConnected', e);
  }

  render = async () => {
    await api.putTurbo(this.renderPathValue, new FormData(this.form));
  }

  // Direct-mode "Apply class code defaults": one-shot flag consumed (and
  // cleared) server-side by ContractsController#render_contract. Also cleared
  // here in case the render fails and the form isn't replaced — otherwise the
  // stale flag would re-apply defaults on the next render. Must reset to ""
  // (not "0"): the server checks `present?`, and "0" is present in Ruby.
  applyClassCodeDefaults = async () => {
    const flag = this.form.querySelector<HTMLInputElement>('input[name="contract[apply_class_code_defaults]"]')
    if (flag) flag.value = "1"
    try {
      await this.render()
    } finally {
      if (flag) flag.value = ""
    }
  }
}
